import {Col, Row} from 'antd';
import React from 'react';

import InformativeText from '../../../../../../constants/InformativeText';
import {convertPxToRem} from '../../../../../../utils/commonFunctions';
import TotalChartList from '../../../../components/TotalChartList';
import ValueRepresentationBox from '../../../../components/ValueRepresentationBox';
import {rowGutterNZM} from '../../../../constants/commonConstants';
import AllSuppliers from '../../../../supplyChain/utils/AllSuppliers';

const OperationalElec: React.FC<{data: any[]}> = ({data}) => {
  const elecInfo = InformativeText?.NZM?.utility?.electricity;

  return (
    <>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(451)}}>
        <Col span={24}>
          <TotalChartList
            chartType="line"
            showTotal={false}
            keyArray={['scope 2 emission trends over time']}
            data={data}
            dataInMainData={true}
            showChartList={false}
          />
        </Col>
      </Row>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(654)}}>
        <Col span={10}>
          <Row gutter={rowGutterNZM} style={{height: convertPxToRem(654)}}>
            <Col span={12}>
              <ValueRepresentationBox
                data={data}
                mainKey="emission per employee"
              />
            </Col>
            <Col span={12}>
              <ValueRepresentationBox
                data={data}
                mainKey="scope 2 emissions per unit of production or revenue"
              />
            </Col>
            <Col span={12}>
              <ValueRepresentationBox
                data={data}
                mainKey="scope 2 emissions per sq m of floor area"
              />
            </Col>
            <Col span={12}>
              <ValueRepresentationBox
                data={data}
                mainKey="emission intensity per kWh of electricity consumed"
                tooltip={
                  elecInfo?.Emission_intensity_per_KWh_of_electricity_consumed
                }
              />
            </Col>
          </Row>
        </Col>
        <Col span={14}>
          <AllSuppliers
            data={data}
            keyArray={['scope 2 emissions by facility']}
            type="electricFacility"
            customTitle="TOTAL EMISSIONS"
            sumOfKey="value"
          />
        </Col>
      </Row>
    </>
  );
};

export default OperationalElec;
